export default __webpack_public_path__ + "static/media/Run (8).53128e6b.png";